import styles from "./ProgressBar.module.css";

export default function ProgressBar({progress}) {
    return(
        <div className={styles.content}>
            <div className={styles.progressBar}> 
                <div className={styles.tracker} style={{width: progress+"%"}}></div>
                <p><span>{progress}%</span> Complete</p>
            </div>
        </div>
    )
}